import store from "@/store";
// @ts-ignore
import { Notification } from "element-ui";
import { goHome } from "@/utils";

// eslint-disable-next-line
function setVal(vueIns, keyStr, val) {
  if (keyStr.indexOf(".") < 0) {
    if (!vueIns[keyStr]) return;
    vueIns[keyStr] = val;
  } else {
    const arr = keyStr.split(".");
    const newKey = arr.shift();
    if (!newKey) return;
    setVal(vueIns[newKey], arr.length > 1 ? arr.join(".") : arr[0], val);
  }
}
// eslint-disable-next-line
function getVal(vueIns, keyStr) {
  if (keyStr.indexOf(".") < 0) {
    if (!vueIns[keyStr]) return null;
    return vueIns[keyStr];
  } else {
    const arr = keyStr.split(".");
    const newKey = arr.shift();
    if (!newKey) return null;
    return getVal(vueIns[newKey], arr.length > 1 ? arr.join(".") : arr[0]);
  }
}

export default {
  methods: {
    /**
     * @description:全局判空赋值
     * @param : defaultStr 对象不存在时候默认展示字符串
     * @return {*}
     */
    // eslint-disable-next-line
    $emptyCheck(obj, key, defaultStr) {
      if (!obj) return defaultStr || "-";
      if (!obj[key]) return defaultStr || "-";
      return obj[key];
    },

    /**
     * @description: 返回首页
     * @param {*}
     * @return {*}
     */
    $goHome() {
      goHome();
    },

    /**
     * @description:  输入框限制
     * @param {*}
     * @return {*}
     */
    $limit(conf) {
      // eslint-disable-next-line
      const vueInstance = this;
      const {
        key,
        type,
        regExpInfo,
        limitLen,
        limitNum,
        limitVal,
        errText
      } = conf;

      if (!vueInstance || !key || !type) return;

      // 值类型
      if (type.indexOf("val") > -1 && limitVal) {
        let { min, max } = limitVal;
        max = max || 0;
        min = min || 0;
        if (max && getVal(vueInstance, key) > max)
          setVal(vueInstance, key, max);
        if (min && getVal(vueInstance, key) < min)
          setVal(vueInstance, key, min);
      }

      // 长度限制
      if (type.indexOf("len") > -1 && limitLen) {
        const currentVal =
          getVal(vueInstance, key) && getVal(vueInstance, key).toString();
        if (currentVal && currentVal.length > limitLen) {
          setVal(vueInstance, key, currentVal.substr(0, limitLen));
        }
      }

      // 正则判断
      if (type.indexOf("regExp") > -1 && regExpInfo) {
        const currentVal = getVal(vueInstance, key);
        // 注意这里不能用regExpInfo.test(xxx)会报错，改用new RegExp(xxx);
        if (!regExpInfo.test(currentVal)) {
          Notification({
            title: "",
            type: "error",
            message: errText || "regExp error"
          });
        }
      }

      // 数值限制
      if (type.indexOf("num") > -1) {
        let currentVal =
          getVal(vueInstance, key) && getVal(vueInstance, key).toString();
        if (!currentVal) return;

        // 输入值只能为数字
        if (/[a-zA-Z]+/g.test(currentVal)) {
          currentVal = currentVal.replace(/[a-zA-Z]/g, "");
          setVal(vueInstance, key, currentVal);
        }

        if (!limitNum) return;
        const { intLen, digitalLen } = limitNum;
        // 无小数点
        if (currentVal.indexOf(".") < 0) {
          if (intLen && currentVal.length > intLen)
            setVal(vueInstance, key, currentVal.substr(0, intLen));
        } else {
          // 存在小数点
          let [front, end] = currentVal.split(".");
          if (intLen && front.length > intLen) front = front.substr(0, intLen);
          if (digitalLen && end.length > digitalLen)
            end = end.substr(0, digitalLen);
          setVal(vueInstance, key, Number(`${front}.${end}`));
        }
      }
    }
  },
  //example
  computed: {
    $isLogin() {
      return store.getters.isLogin;
    },
    $userInfo() {
      return store.getters.getUserInfo;
    },
    $currencyData() {
      return store.getters.getCurrencyData;
    },
    $miningTechnology() {
      const coin = this.$currencyData.find(
        (event) => event.coinCode == this.$miningType
      );
      return coin && coin.miningTechnology || 1;
    },
    $accountName() {
      return store.getters.getAccountName;
    },
    $searchCoin() {
      return store.getters.getSearchCoin;
    },
    $showCoin() {
      return store.getters.getShowCoin;
    },
    $showModify() {
      return store.getters.getShowModify;
    },
    $miningType() {
      return store.getters.getMiningType;
    },
    $walletAddr() {
      return store.getters.getWalletAddr;
    },
  }
};



// WEBPACK FOOTER //
// ./src/mixins/index.js